import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/pago/ok")({
  head: () => ({ meta: [{ title: "Pago confirmado · El Pajar de Benito" }, { name: "robots", content: "noindex" }] }),
  component: PagoOk,
});

function PagoOk() {
  return (
    <section className="mx-auto max-w-xl px-4 py-24 text-center">
      <p className="text-xs uppercase tracking-[0.28em] text-accent">Pago</p>
      <h1 className="mt-3 font-serif text-4xl text-foreground">Pago confirmado</h1>
      <p className="mt-5 text-muted-foreground">
        Hemos recibido tu pago correctamente. Te enviaremos un email de confirmación en breve.
      </p>
      <Link to="/" className="mt-8 inline-block rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90">
        Volver al inicio
      </Link>
    </section>
  );
}